import React, { Component, Fragment } from 'react';

import { withRouter, Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import './cityDropDown.css';

class NavbarGeneralCities extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderCityName = () => {
    const { history } = this.props;
    const { pathname } = history.location;

    if (pathname.includes('nyc')) {
      return (
        <Fragment>
          <FontAwesomeIcon
            icon={faMapMarkerAlt}
            className="city-location-icon"
          />
          {'New York City'}
        </Fragment>
      );
    } else if (pathname.includes('/tor')) {
      return (
        <Fragment>
          <FontAwesomeIcon
            icon={faMapMarkerAlt}
            className="city-location-icon"
          />
          {'Toronto'}
        </Fragment>
      );
    } else if (
      pathname.includes('/sf') ||
      pathname.includes('/investors')
    ) {
      return (
        <Fragment>
          <FontAwesomeIcon
            icon={faMapMarkerAlt}
            className="city-location-icon"
          />
          {'San Francisco'}
        </Fragment>
      );
    } else if (pathname.includes('/la')) {
      return (
        <Fragment>
          <FontAwesomeIcon
            icon={faMapMarkerAlt}
            className="city-location-icon"
          />
          {'Los Angeles'}
        </Fragment>
      );
    } else if (pathname.includes('/ott')) {
      return (
        <Fragment>
          <FontAwesomeIcon
            icon={faMapMarkerAlt}
            className="city-location-icon"
          />
          {'Ottawa'}
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <FontAwesomeIcon
            icon={faMapMarkerAlt}
            className="city-location-icon"
          />
          {'Toronto'}
        </Fragment>
      );
    }
  };

  render() {
    return (
      <li className="dropdown">
        <div className="city-link dropdown-toggle city-name">
          {this.renderCityName()}
        </div>
      </li>
    );
  }
}

export default withRouter(NavbarGeneralCities);



// WEBPACK FOOTER //
// ./src/components/Layout/NavbarGeneralCities.js